import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useSelector } from 'react-redux'

import { identifyTeacher } from 'utils/logrocket'

// Renders nothing. It exists so the LogRocket session gets tagged with the teacher
// as soon as Auth0 resolves, then again once the roster fetch supplies the backend
// teacher id. Keeping it in its own component means store updates re-render this
// instead of the whole app.
const LogRocketIdentity = () => {
  const { user } = useAuth0()
  const teacherId = useSelector((state) => state.classroom.teacher.id)

  useEffect(() => {
    identifyTeacher({ user, teacherId })
  }, [user, teacherId])

  return null
}

export default LogRocketIdentity
